export const ru = {
    'empty-header': 'Ключевые фразы не выбраны',
    'empty-text': 'Здесь будет список ключевых фраз, которые можно добавить к группе объявлений',
    'remove-action': 'Очистить список',
    title: 'Ключевые фразы'
};
